import { useState } from "react";
import { useDispatch } from "react-redux";
import { Box, Grid, Typography } from "@mui/material";
import ModalButton from "./modalButton/modalButton";
import InputFields from "./InputFields";
import { useForm } from "react-hook-form";
import TextAreaFields from "./textAreaFields";
import ButtonContainer from "./buttonContainer";
import SaveButton from "./saveButton/saveButton";
import * as XLSX from "xlsx";
import axios from "axios";
import { api } from "../interfaces/api.interface";
import { uiActions } from "../store/reducers/ui-slice";
import excelExport from '../assets/excel_export.png'
import { emailRegex } from "../utils/Utils";

const SendEmail = (props) => {
    const { dataList, name } = props
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);

    const [isLoading, setIsLoading] = useState(false)

    const defaultValues = useForm({
        defaultValues: {
            to: "",
            cc: "",
            subject: "",
            body: "",
        },
    });

    const {
        control,
        handleSubmit,
        setError,
        clearErrors,
        watch,
        reset,
        resetField,
        getValues,
        formState: { errors },
    } = defaultValues;
    console.log(dataList)

    const submit = () => {
        setIsLoading(true)
        const formData = new FormData();
        formData.append('ToEmail', watch('to'));
        formData.append('CCEmail', watch('cc'));
        formData.append('Subject', watch('subject'));
        formData.append('Body', watch('body'));
        const headerMap = {
            diN_Master: "DIN Master",
            productName: "Product Name",
            mg: "Mg",
            packSizeValue: "Pack Size",
            qty: "Quantity",
        };

        const formattedData = dataList.map(item => {
            const obj = {};
            Object.keys(headerMap).forEach(key => {
                obj[headerMap[key]] = item[key];
            });
            return obj;
        });
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });

        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        const file = new File([blob], `${name}.xlsx`, {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        formData.append("File", file);
        // if (watch('to')) {
        //     formData.append('attachment', watch('to'));
        // }
        const url = api.emailSend().url
        const method = api.emailSend().method
        axios[method](url, formData).then(res => {
            if (res.status == 200) {
                setOpen(false)
                dispatch(uiActions.showNotification({
                    status: "success",
                    title: "Authorized!",
                    message: "Email has been sent successfully",
                }))
            }
            setIsLoading(false)
        })
        console.log(formData)
    }

    return (
        <ModalButton open={open} setOpen={setOpen} tooltip={'Email'} type={'button'} >
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <InputFields
                        fieldName="to"
                        type="text"
                        label="To"
                        control={control}
                        rules={{
                            required: "To is required",
                            validate: (value) => {
                                if (!emailRegex.test(value)) {
                                    return " Incorrect Email"
                                }
                            }
                        }}
                        error={errors?.to}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputFields
                        fieldName="cc"
                        type="text"
                        label="CC"
                        control={control}
                        rules={{
                            // required: "CC is required",
                            validate: (value) => {
                                if (!emailRegex.test(value)) {
                                    return " Incorrect Email"
                                }
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <InputFields
                        fieldName="subject"
                        type="text"
                        label="Subject"
                        control={control}
                        rules={{
                            required: "Subject is required",
                        }}
                        error={errors?.subject}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextAreaFields
                        fieldName="body"
                        type="text"
                        label="Body"
                        control={control}
                        rows={5}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', gap: '10px', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '10px', border: '1px solid #e0e0e0', borderRadius: '5px', width: '100px' }}>
                        <img src={excelExport} style={{ width: '50px', objectFit: 'contain' }} />
                        <Typography variant='body2' sx={{
                            textWrap: 'wrap',
                            textAlign: 'center'
                        }} >{`${name}.xlsx`}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <ButtonContainer isSingle>
                        <SaveButton isLoading={isLoading} onClick={handleSubmit(submit)} title={'Save'} />
                    </ButtonContainer>
                </Grid>
            </Grid>
        </ModalButton>
    );
};

export default SendEmail;
